import { Injectable } from "@angular/core";
import { defer, Observable, of } from "rxjs";
import { BaseApiClientLabelsService } from "src/app/api/base-api-client-labels.service";
import { HttpClientHelperService } from "src/app/api/http-client-helper.service";
import { AssessmentCustomLabel } from "src/app/api/models/assessments/assessment.interface";
import { FeatureFlagQuery } from "src/app/feature-flag/state/feature-flag.query";
import { FeatureFlags } from "src/app/api/models/profile/profile-feature-flags.enum";

@Injectable({
  providedIn: 'root'
})
export class ApiClientCollaborationLabelsService extends BaseApiClientLabelsService {

  /** Read-only company tags for collaborators (BE contract #13); create / update / delete stay portal-only. */
  private readonly collaborationController = 'assessment/v4/collaboration/tag';

  constructor(
    httpClientHelper: HttpClientHelperService,
    private featureFlagQuery: FeatureFlagQuery,
  ) {
    super(httpClientHelper);
  }

  override getLabels(): Observable<AssessmentCustomLabel[]> {
    // The labels store calls this eagerly in its constructor, possibly before the feature flags have loaded,
    // so the flag is read on subscribe (i.e. on `AssessmentsLabelsService.init()`), not on creation.
    // Flag off: the collaboration surface has no labels, as before.
    return defer(() => this.featureFlagQuery.getFlag(FeatureFlags.DevRiskLabels)
      ? this.httpClientHelper.invokeGetAuth<AssessmentCustomLabel[]>(this.collaborationController)
      : of([]));
  }
}
